module.exports = __webpack_public_path__ + "static/img/term_library_download_batch.8d42c18c.gif";